import React from "react";
import { Main } from "components/Main";

import { setToken } from "api/ApiClientBase";
import { msalInstance, init, MsalOptions } from "api/security";

import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.light.css";
import { accountService } from "api/AccountService";
import { User } from "api/User";

function App() {
    const [user, setUser] = React.useState<User>();
        const [msalOptions, setMsalOptions] = React.useState<MsalOptions>();

    React.useEffect(() => {
        accountService.MSALOptions().then((opt) => {
            // get options only once
            init(opt);
            setMsalOptions(opt);

            // TODO: acquireTokenSilent every ajax request
            msalInstance
                .acquireTokenSilent({ scopes: ["openid"] })
                .then((val) => {
                    setUser({ name: val.account.userName, roles: (val.idTokenClaims as any).roles });
                    setToken(val.idToken.rawIdToken);
                })
                .catch((err) => {
                    msalInstance.loginRedirect();
                });
        });
    }, []);

    if (msalOptions === undefined) {
        return null;
    }

    return user ? <Main user={user} onLogout={() => msalInstance.logout()} /> : null;
}

export default App;
